import { dia, util, shapes } from "@clientio/rappid";
import { Region } from "./region";
import SpecificationElement from "./base/specification-element";
import DocumentationElement from "./base/documentation-element";
import { removeStaticAttributes } from "./base/utils";

export const STATECHART_ID = "statechart-root";

export class Statechart extends dia.Element implements SpecificationElement, DocumentationElement {
  defaults() {
    return {
      ...super.defaults,
      type: "Statechart",
      id: "statechart-root",
      linkable: false,
      size: {
        height: 10,
        width: 10,
      },
      attrs: {
        body: {
          fillOpacity: 1,
        },
        name: {
          text: "",
        },
        specification: {
          text: "",
          show: true,
        },
        documentation: {
          text: "",
        },
      },
    };
  }

  markup = [
    {
      tagName: "rect",
      selector: "body",
    },
  ];

  getSpecification(): string {
    return this.attr(["specification", "text"]);
  }

  setSpecification(spec: string) {
    this.attr(["specification", "text"], spec);
  }

  getSpecificationType(): string {
    return "statechart";
  }

  getShowSpecification(): boolean {
    return this.attr(["specification", "show"]);
  }

  setShowSpecification(show: boolean) {
    this.attr(["specification", "show"], show);
  }

  getDocumentation(): string {
    return this.attr(["documentation", "text"]);
  }

  setDocumentation(documentation: string) {
    this.attr(["documentation", "text"], documentation);
  }

  getDocumentationType(): string {
    return "Statechart";
  }

  setName(name: string) {
    this.attr(["name", "text"], name);
  }

  getName(): string {
    return this.attr(["name", "text"]);
  }

  getTopLevelRegions(): Array<Region> {
    return (
      this.graph
        ?.getElements()
        .filter((e) => e instanceof Region)
        .map((e) => e as Region)
        .filter((r) => r.getParentCell() === null)
        .sort((a, b) => {
          if (a.index() === 0) return 1;
          if (b.index() === 0) return -1;
          return a.index() - b.index();
        }) || []
    );
  }

  updateTopLevelRegionPriorities() {
    this.getTopLevelRegions().forEach((t, i) => {
      t.index(i + 1);
    });
  }

  getCyclePeriod(): number {
    const spec = this.getSpecification();
    const found = spec.match(/@CycleBased\((\d+)\)/i);
    return found && found.length === 2 ? Number.parseInt(found[1]) : -1;
  }

  toJSON() {
    const result = super.toJSON();
    return removeStaticAttributes(result);
  }
}

util.assign(shapes, {
  Statechart,
});
